import $ from 'jquery';

class Accordion {
	/**
	 *
	 * @param element
	 * @param options
	 */
	constructor(element, options) {
		const $element = $(element);
		const config = $.extend({
			items: 'accordion__faq-dt',
			icon: 'accordion__svg-icon',
			active: 'is-open',
			inactive: 'is-closed',
			autoclose: true
		}, options);

		this.init($element, config);
	}

	/**
	 *
	 * @param $element
	 * @param config
	 */
	init($element, config) {
		this.initalState($element, config);
		this.initListener($element, config);
	}

	/**
	 *
	 * @param $element
	 * @param config
	 */
	initalState($element, config) {
		const $items = $element.find('.' + config.items);

		$items.each((index, element) => {
			$(element).addClass(config.inactive);
			$(element).removeClass(config.active);
		});

	}

	/**
	 *
	 * @param $element
	 * @param config
	 */
	initListener($element, config) {
		const $items = $element.find('.' + config.items);

		$items.each((index, element) => {
			this.itemListener($element, $(element), config);
		});

		$(window).on('hashchange', () => {
			this.hashListener($element, config);
		});

		$(document).ready(() => {
			this.hashListener($element, config);
		});
	}

	/**
	 *
	 * @param $element
	 * @param $item
	 * @param config
	 */
	itemListener($element, $item, config) {
		$item.off('click.accordion');
		$item.on('click.accordion', () => {

			if (config.autoclose === false) {
				this.initalState($element, config);
			}

			this.toggleState($item, config);
		});
	}

	/**
	 *
	 * @param $element
	 * @param config
	 */
	hashListener($element, config) {
		const hash = window.location.hash.toLowerCase();
		const index = this.headerForHash(hash, $element, config);

		if (index > -1) {
			const $item = $element.find('.' + config.items).eq(index);

			$item.trigger('click');
			this.trigger(this.getEvent($item));
		}

	}

	/**
	 *
	 * @param $element
	 * @param config
	 */
	toggleState($element, config) {
		$element.toggleClass(config.active);
		$element.toggleClass(config.inactive);

		let currentExpanded = $element.attr('aria-expanded') === 'true';

		if (currentExpanded) {
			$element.attr('aria-expanded', 'false');
		} else {
			$element.attr('aria-expanded', 'true');
		}
	}

	/**
	 *
	 * @param hash
	 * @param $element
	 * @param config
	 * @returns {number}
	 */
	headerForHash(hash, $element, config) {
		const $items = $element.find('.' + config.items);

		let faqIndex = -1,
			faqHeader;

		$items.each((index, element) => {
			faqHeader = $(element).text();

			if (hash === this.buildHash(faqHeader)) {
				faqIndex = index;
			}
		});

		return faqIndex;
	}

	/**
	 *
	 * @param str
	 * @returns {*|string}
	 */
	buildHash(str) {
		let string = str || '';

		string = string.trim();
		string = this.replaceUmlaut(string);
		string = string.match(/[a-zA-Z0-9]+/g).join('-');
		string = '#' + string.toLowerCase();

		return string;
	}

	/**
	 *
	 * @param str
	 * @returns {*|string}
	 */
	replaceUmlaut(str) {
		const replacements = {
			'\u00dc': 'Ue',
			'\u00fc': 'ue',
			'\u00c4': 'Ae',
			'\u00e4': 'ae',
			'\u00d6': 'Oe',
			'\u00f6': 'oe',
			'\u00df': 'ss'
		};

		let regex,
			string = str || '';

		for (let key of Object.keys(replacements)) {
			regex = new RegExp(key, 'g');
			string = string.replace(regex, replacements[key]);
		}

		return string;
	}

	/**
	 *
	 * @param event
	 */
	trigger(event) {
		document.dispatchEvent(event);
	}

	/**
	 *
	 * @param $element
	 * @returns {CustomEvent}
	 */
	getEvent($element) {
		return new CustomEvent('SCROLLTO', {
			detail: {
				element: $element
			}
		});
	}

}

export default Accordion;



// WEBPACK FOOTER //
// ./js/modules/accordion.js